function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import Location from '../geom/Location';
import Position from './Position';
import TopologyException from '../geom/TopologyException';
import EdgeEndStar from './EdgeEndStar';
import System from '../../../../java/lang/System';
import Label from './Label';
import ArrayList from '../../../../java/util/ArrayList';
import Quadrant from './Quadrant';
import Assert from '../util/Assert';
var DirectedEdgeStar = /*#__PURE__*/function (_EdgeEndStar) {
  function DirectedEdgeStar() {
    var _this;
    _classCallCheck(this, DirectedEdgeStar);
    _this = _callSuper(this, DirectedEdgeStar);
    DirectedEdgeStar.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(DirectedEdgeStar, _EdgeEndStar);
  return _createClass(DirectedEdgeStar, [{
    key: "linkResultDirectedEdges",
    value: function linkResultDirectedEdges() {
      this.getResultAreaEdges();
      var firstOut = null;
      var incoming = null;
      var state = this._SCANNING_FOR_INCOMING;
      for (var i = 0; i < this._resultAreaEdgeList.size(); i++) {
        var nextOut = this._resultAreaEdgeList.get(i);
        var nextIn = nextOut.getSym();
        if (!nextOut.getLabel().isArea()) continue;
        if (firstOut === null && nextOut.isInResult()) firstOut = nextOut;
        switch (state) {
          case this._SCANNING_FOR_INCOMING:
            if (!nextIn.isInResult()) continue;
            incoming = nextIn;
            state = this._LINKING_TO_OUTGOING;
            break;
          case this._LINKING_TO_OUTGOING:
            if (!nextOut.isInResult()) continue;
            incoming.setNext(nextOut);
            state = this._SCANNING_FOR_INCOMING;
            break;
        }
      }
      if (state === this._LINKING_TO_OUTGOING) {
        if (firstOut === null) throw new TopologyException('no outgoing dirEdge found', this.getCoordinate());
        Assert.isTrue(firstOut.isInResult(), 'unable to link last incoming dirEdge');
        incoming.setNext(firstOut);
      }
    }
  }, {
    key: "insert",
    value: function insert(ee) {
      var de = ee;
      this.insertEdgeEnd(de, de);
    }
  }, {
    key: "getRightmostEdge",
    value: function getRightmostEdge() {
      var edges = this.getEdges();
      var size = edges.size();
      if (size < 1) return null;
      var de0 = edges.get(0);
      if (size === 1) return de0;
      var deLast = edges.get(size - 1);
      var quad0 = de0.getQuadrant();
      var quad1 = deLast.getQuadrant();
      if (Quadrant.isNorthern(quad0) && Quadrant.isNorthern(quad1)) return de0;else if (!Quadrant.isNorthern(quad0) && !Quadrant.isNorthern(quad1)) return deLast;else {
        var nonHorizontalEdge = null;
        if (de0.getDy() !== 0) return de0;else if (deLast.getDy() !== 0) return deLast;
      }
      Assert.shouldNeverReachHere('found two horizontal edges incident on node');
      return null;
    }
  }, {
    key: "print",
    value: function print(out) {
      System.out.println('DirectedEdgeStar: ' + this.getCoordinate());
      for (var it = this.iterator(); it.hasNext();) {
        var de = it.next();
        out.print('out ');
        de.print(out);
        out.println();
        out.print('in ');
        de.getSym().print(out);
        out.println();
      }
    }
  }, {
    key: "getResultAreaEdges",
    value: function getResultAreaEdges() {
      if (this._resultAreaEdgeList !== null) return this._resultAreaEdgeList;
      this._resultAreaEdgeList = new ArrayList();
      for (var it = this.iterator(); it.hasNext();) {
        var de = it.next();
        if (de.isInResult() || de.getSym().isInResult()) this._resultAreaEdgeList.add(de);
      }
      return this._resultAreaEdgeList;
    }
  }, {
    key: "updateLabelling",
    value: function updateLabelling(nodeLabel) {
      for (var it = this.iterator(); it.hasNext();) {
        var de = it.next();
        var label = de.getLabel();
        label.setAllLocationsIfNull(0, nodeLabel.getLocation(0));
        label.setAllLocationsIfNull(1, nodeLabel.getLocation(1));
      }
    }
  }, {
    key: "linkAllDirectedEdges",
    value: function linkAllDirectedEdges() {
      this.getEdges();
      var prevOut = null;
      var firstIn = null;
      for (var i = this._edgeList.size() - 1; i >= 0; i--) {
        var nextOut = this._edgeList.get(i);
        var nextIn = nextOut.getSym();
        if (firstIn === null) firstIn = nextIn;
        if (prevOut !== null) nextIn.setNext(prevOut);
        prevOut = nextOut;
      }
      firstIn.setNext(prevOut);
    }
  }, {
    key: "computeDepths",
    value: function computeDepths() {
      if (arguments.length === 1) {
        var de = arguments[0];
        var edgeIndex = this.findIndex(de);
        var startDepth = de.getDepth(Position.LEFT);
        var targetLastDepth = de.getDepth(Position.RIGHT);
        var nextDepth = this.computeDepths(edgeIndex + 1, this._edgeList.size(), startDepth);
        var lastDepth = this.computeDepths(0, edgeIndex, nextDepth);
        if (lastDepth !== targetLastDepth) throw new TopologyException('depth mismatch at ' + de.getCoordinate());
      } else if (arguments.length === 3) {
        var startIndex = arguments[0];
        var endIndex = arguments[1];
        var _startDepth = arguments[2];
        var currDepth = _startDepth;
        for (var i = startIndex; i < endIndex; i++) {
          var nextDe = this._edgeList.get(i);
          nextDe.setEdgeDepths(Position.RIGHT, currDepth);
          currDepth = nextDe.getDepth(Position.LEFT);
        }
        return currDepth;
      }
    }
  }, {
    key: "mergeSymLabels",
    value: function mergeSymLabels() {
      for (var it = this.iterator(); it.hasNext();) {
        var de = it.next();
        var label = de.getLabel();
        label.merge(de.getSym().getLabel());
      }
    }
  }, {
    key: "linkMinimalDirectedEdges",
    value: function linkMinimalDirectedEdges(er) {
      var firstOut = null;
      var incoming = null;
      var state = this._SCANNING_FOR_INCOMING;
      for (var i = this._resultAreaEdgeList.size() - 1; i >= 0; i--) {
        var nextOut = this._resultAreaEdgeList.get(i);
        var nextIn = nextOut.getSym();
        if (firstOut === null && nextOut.getEdgeRing() === er) firstOut = nextOut;
        switch (state) {
          case this._SCANNING_FOR_INCOMING:
            if (nextIn.getEdgeRing() !== er) continue;
            incoming = nextIn;
            state = this._LINKING_TO_OUTGOING;
            break;
          case this._LINKING_TO_OUTGOING:
            if (nextOut.getEdgeRing() !== er) continue;
            incoming.setNextMin(nextOut);
            state = this._SCANNING_FOR_INCOMING;
            break;
        }
      }
      if (state === this._LINKING_TO_OUTGOING) {
        Assert.isTrue(firstOut !== null, 'found null for first outgoing dirEdge');
        Assert.isTrue(firstOut.getEdgeRing() === er, 'unable to link last incoming dirEdge');
        incoming.setNextMin(firstOut);
      }
    }
  }, {
    key: "getOutgoingDegree",
    value: function getOutgoingDegree() {
      if (arguments.length === 0) {
        var degree = 0;
        for (var it = this.iterator(); it.hasNext();) {
          var de = it.next();
          if (de.isInResult()) degree++;
        }
        return degree;
      } else if (arguments.length === 1) {
        var er = arguments[0];
        var _degree = 0;
        for (var _it = this.iterator(); _it.hasNext();) {
          var _de = _it.next();
          if (_de.getEdgeRing() === er) _degree++;
        }
        return _degree;
      }
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this._label;
    }
  }, {
    key: "findCoveredLineEdges",
    value: function findCoveredLineEdges() {
      var startLoc = Location.NONE;
      for (var it = this.iterator(); it.hasNext();) {
        var nextOut = it.next();
        var nextIn = nextOut.getSym();
        if (!nextOut.isLineEdge()) {
          if (nextOut.isInResult()) {
            startLoc = Location.INTERIOR;
            break;
          }
          if (nextIn.isInResult()) {
            startLoc = Location.EXTERIOR;
            break;
          }
        }
      }
      if (startLoc === Location.NONE) return null;
      var currLoc = startLoc;
      for (var _it2 = this.iterator(); _it2.hasNext();) {
        var _nextOut = _it2.next();
        var _nextIn = _nextOut.getSym();
        if (_nextOut.isLineEdge()) {
          _nextOut.getEdge().setCovered(currLoc === Location.INTERIOR);
        } else {
          if (_nextOut.isInResult()) currLoc = Location.EXTERIOR;
          if (_nextIn.isInResult()) currLoc = Location.INTERIOR;
        }
      }
    }
  }, {
    key: "computeLabelling",
    value: function computeLabelling(geom) {
      _superPropGet(DirectedEdgeStar, "computeLabelling", this, 1).call(this, geom);
      this._label = new Label(Location.NONE);
      for (var it = this.iterator(); it.hasNext();) {
        var ee = it.next();
        var e = ee.getEdge();
        var eLabel = e.getLabel();
        for (var i = 0; i < 2; i++) {
          var eLoc = eLabel.getLocation(i);
          if (eLoc === Location.INTERIOR || eLoc === Location.BOUNDARY) this._label.setLocation(i, Location.INTERIOR);
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return DirectedEdgeStar;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}(EdgeEndStar);
export { DirectedEdgeStar as default };
DirectedEdgeStar.constructor_ = function () {
  this._resultAreaEdgeList = null;
  this._label = null;
  this._SCANNING_FOR_INCOMING = 1;
  this._LINKING_TO_OUTGOING = 2;
};